import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ChangeShippingAddressForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeSubscriptionShippingAddress, requestNewSubscriptionShippingAddress} from "../../actions/AccountApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ChangeShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      selectedId: "current",
      errors: [] 
    }
  }

  handleSubmit(values) {
    if (this.state.selectedId === "current") {
      this.props.cancelChangeSubscriptionShippingAddress();
    } else {
      return this.props.assignSubscriptionExistingShippingAddress({subscriptionId: this.props.subscriptionId, accountId: this.props.accountId, addressId: this.state.selectedId})
        .then((response) => {
          if (response.data.assignSubscriptionExistingShippingAddress.errors.length <= 0) {
            this.props.cancelChangeSubscriptionShippingAddress();
          } else {
            let errors = createValidationErrors(response.data.assignSubscriptionExistingShippingAddress.errors);
            this.setState({errors: errors});            
          }
        })
        .catch((err) => {
          this.setState({errors: createErrors(err)});
        });      
    }
  }

  handleCancel() {
    this.props.cancelChangeSubscriptionShippingAddress();
  }

  handleNewAddress() {
    this.props.requestNewSubscriptionShippingAddress(this.props.accountId, this.props.subscriptionId);
  }

  handleSelectAddressId(id) {
    this.setState({
      selectedId: id
    })
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    return (
      <Form
        errors={this.state.errors}
        selectedAddress={fromJS(data.subscriptionInfo.shippingAddress)}
        usedShippingAddresses={fromJS(data.shippingAddresses)}
        selectedId={this.state.selectedId}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onNewAddress={this.handleNewAddress.bind(this)}
        onSelect={this.handleSelectAddressId.bind(this)}
        />
    )
  }
}

const ACCOUNT_ADDRESSES = gql`
  query addresses($accountId:ID!, $subscriptionId:ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode
      }
    }
    shippingAddresses(accountId: $accountId) {
      addressId
      address {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode
      }
    }
  }
`;

const ASSIGN_EXISTING_ADDRESS = gql`
  mutation assignSubscriptionExistingShippingAddress($data: SubscriptionExistingShippingAddressInput!) {
    assignSubscriptionExistingShippingAddress(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(ACCOUNT_ADDRESSES, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId,
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(ASSIGN_EXISTING_ADDRESS, {
    props: ({ mutate }) => ({
      assignSubscriptionExistingShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelChangeSubscriptionShippingAddress, requestNewSubscriptionShippingAddress})(withQueries(ChangeShippingAddressFormContainer));